import type { SVGProps } from 'react';
const SvgContactMail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#contact_mail_svg__a)">
      <path
        fill="currentColor"
        d="M21 8V7l-3 2-3-2v1l3 2 3-2Zm1-5H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2ZM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3Zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1Zm8-6h-8V6h8v6Z"
      />
    </g>
    <defs>
      <clipPath id="contact_mail_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgContactMail;
